import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Header from "@/components/Header";
import api from "@/lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState({ loading: true, ok: false, email: null, already: false, error: null });

  useEffect(() => {
    if (!token) {
      setState({ loading: false, ok: false, email: null, already: false, error: "Missing token." });
      return;
    }
    api.get(`/community/unsubscribe?token=${encodeURIComponent(token)}`)
      .then(({ data }) => setState({ loading: false, ok: true, email: data.email, already: data.already_unsubscribed, error: null }))
      .catch((e) => setState({ loading: false, ok: false, email: null, already: false, error: e?.response?.data?.detail || "We could not process this unsubscribe link." }));
  }, [token]);

  return (
    <div className="min-h-screen bg-forge-900 text-forge-100">
      <Header />
      <main className="max-w-2xl mx-auto px-6 py-20 sm:py-28">
        <div className="text-[10px] tracking-[0.4em] uppercase text-gold-500 mb-4">Unsubscribe</div>

        {state.loading && <p className="text-sm tracking-[0.3em] uppercase text-ember-500 animate-pulse">Processing…</p>}

        {!state.loading && state.ok && (
          <div data-testid="unsubscribe-success">
            <h1 className="font-serif text-4xl tracking-tight mb-3">
              {state.already ? "Already unsubscribed." : "You're unsubscribed."}
            </h1>
            <p className="font-reading text-lg text-forge-100/75 leading-relaxed mb-6">
              {state.email ? <>We will no longer send broadcasts to <span className="text-ember-400">{state.email}</span>.</> : "We will no longer send broadcasts to you."}
            </p>
            <p className="text-sm text-forge-100/55 mb-10">
              Your account, journal, and reading history are untouched. You can re-join the community at any time.
            </p>
            <div className="flex flex-wrap gap-3">
              <Link to="/" className="px-5 py-2.5 border border-white/15 hover:border-ember-500 hover:text-ember-400 text-sm tracking-wide rounded-sm transition-all">← Back to ThoughtSmith™</Link>
              <Link to="/community" className="px-5 py-2.5 bg-ember-500 hover:bg-ember-400 text-forge-900 font-semibold tracking-wide rounded-sm transition-all">Re-join the Community</Link>
            </div>
          </div>
        )}

        {!state.loading && !state.ok && (
          <div data-testid="unsubscribe-error">
            <h1 className="font-serif text-4xl tracking-tight mb-3">We couldn't process that link.</h1>
            <p className="text-sm text-forge-100/65 mb-8">{state.error}</p>
            <Link to="/" className="px-5 py-2.5 border border-white/15 hover:border-ember-500 hover:text-ember-400 text-sm tracking-wide rounded-sm transition-all">← Back to ThoughtSmith™</Link>
          </div>
        )}
      </main>
    </div>
  );
}
